<template>
  <span v-if="isEmpty" class="empty-value-chip">-</span>
  <span v-else>
    <slot>{{ displayValue }}</slot>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmptyValueChip',
  props: {
    value: {
      type: null,
      default: '',
    },
  },
  computed: {
    displayValue(): string {
      return String(this.value)
    },
    isEmpty(): boolean {
      if (this.value === null || this.value === undefined) return true
      const text = String(this.value).trim()
      return text === '' || text === '-'
    },
  },
})
</script>

<style scoped>
.empty-value-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  background: #f4f6f8;
  color: #7b8794;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}
</style>
